module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ../~/css-animation/~/babel-runtime/core-js/symbol.js
 ** module id = 1340
 ** module chunks = 3
 **/